import React from 'react';

import {
    ITreeSelectDataSource,
    ITreeSelectItemProps,
    ITreeSelectProps,
    TextFieldItem,
    TreeSelect,
    TreeSelectItem,
} from 'ui-lib';
import { MAX_DEVICE_IDENTIFIER_LENGTH } from '../../../common-utils';

export interface IDeviceGroupSelectProps {
    className?: string;
    placeholder?: string;
    expandAll?: boolean;
    allowClear?: boolean;
    value?: string;
    treeDataSource: ITreeSelectDataSource | ITreeSelectDataSource[];
    disabled?: boolean;
    onChange?: (value: any, labelList: React.ReactNode[], extra: any) => void;
    filterTreeNode?: (inputValue: string, treeNode: { value: string; label: string; key: string }) => boolean;
}

export const DeviceGroupMultipleSelect = (props: ITreeSelectProps) => {
    return <TreeSelect {...props} multiple={true} />;
};

export const DeviceGroupMultipleSelectItem = (props: ITreeSelectItemProps) => {
    return <TreeSelectItem {...props} selectProps={{ ...props.selectProps, multiple: true }} />;
};

export const DeviceGroupSelectItem = (props: ITreeSelectItemProps) => <TreeSelectItem {...props} />;

export const DeviceGroupSelect = (props: IDeviceGroupSelectProps) => {
    return (
        <TreeSelect
            className={props.className}
            filterTreeNode={props.filterTreeNode}
            key='deviceGroup'
            placeholder={props.placeholder || 'Device Group'}
            allowClear={props.allowClear}
            expandAll={props.expandAll}
            selectValue={props.value}
            dataSource={props.treeDataSource}
            disabled={props.disabled}
            onChange={props.onChange}
        />
    );
};

export interface IDeviceIdentifierItemProps {
    code?: string;
    label?: string;
    labelAlign?: 'left' | 'right';
    initialValue?: string;
    extraValidator?: (value: any) => boolean;
    onChange?: (value: any) => void;
    isRequired?: boolean;
    colon?: boolean;
}

export const DeviceIdentifierItem = (props: IDeviceIdentifierItemProps) => {
    const deviceNameValidator = (rule, value, callback) => {
        if (props.extraValidator && !props.extraValidator(value))
            return callback('Please provide a valid Device UID, serial number or eSN.');

        if (!props.isRequired && !value) return callback();

        if (!value || !value.match('^([A-Za-z0-9_]+)$'))
            return callback('Please provide a valid Device UID, serial number or eSN.');

        if (value.length > MAX_DEVICE_IDENTIFIER_LENGTH) return callback('Please enter not more than 32 symbols.');

        return callback();
    };

    return (
        <TextFieldItem
            code={props.code || 'deviceIdentifierField'}
            label={props.label || 'Device'}
            placeholder='UID, serial number or eSN'
            allowClear={true}
            labelAlign={props.labelAlign}
            initialValue={props.initialValue}
            validator={deviceNameValidator}
            value={props.initialValue}
            onChange={props.onChange}
            isRequired={props.isRequired}
            colon={props.colon}
        />
    );
};
